/*eslint-disable @typescript-eslint/no-unused-vars*/

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { DashboardHeader, downloadFile, FilterLayout, FilterProp, renderHeaderActionButtons, SearchBox, SelectDropDown, SidePopover, TableLayout, TableSubHeader, useAppDispatch, useAppSelector, useEffectOnce } from '../../../../globalUtils/globalExports';
import ChargerInventoryParameterChangeLogRowCard from './ChargerInventoryParameterChangeLogRowCard';
import './chargerInventoryParameterChangeLogDashboard.css';
import { chargerTypes, clearInventoryParamIndividualComponentDetailsComponent, exportInventoryParameterChangeLogs, fetchInventoryParamComponentsReferenceData, fetchInventoryParameterChangeLogs, fetchInventoryParamIndividualComponentDetailsComponent, getChargerReducer, getCurrentFiltersValues, getCurrentScreenAppliedFiltersCount, getFilterReducer, getFilterSelectedValue, getReferenceDataReducer, setFilterData, setInventoryParameterChangeLogsTableProps, setRedirectedStateForInventoryParameterChangeLogsFilters } from '../../../../rmsReduxStore/reduxExports';
import { useLocation } from 'react-router-dom';
import InventoryParamCurrentStatusCard from './InventoryParamCurrentStatusCard';
import { Menu, MenuItem } from '@mui/material';
import { Id, toast } from 'react-toastify';
import { NoDataComponentInventoryParamChangeLog } from '../../../../globalUtils/TableDashboard/TableComponents';
import { cloneDeep } from 'lodash';
import { Icon, IconWithTooltip } from '../../../../globalUtils/globalIcons';


interface ChargerInventoryParameterChangeLogDashboardProps {
    handleCloseIconClicked: ()=>void
}

const ChargerInventoryParameterChangeLogDashboard: React.FC<ChargerInventoryParameterChangeLogDashboardProps> = ({handleCloseIconClicked}) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const {chargerInventoryParameterChangeLogs, chargerInventoryParameterChangeLogsCount, chargerInventoryParameterChangeLogsListLoader, chargerInventoryParameterChangeLogsListTableProps, chargerInventoryParameterChangeLogsFiltersAppliedFromRedirection,inventoryParameterIndividualComponentDetails } = useAppSelector(getChargerReducer);
    const {inventoryParamChangeLogFieldNameReferenceData, inventoryParamChangeLogChangeTypeReferenceData, inventoryParamComponentsReferenceData} = useAppSelector(getReferenceDataReducer);
    const { screenFilters } = useAppSelector(getFilterReducer);
    const dashboardRef = useRef<HTMLDivElement | null>(null);
    const headerRef = useRef<HTMLDivElement | null>(null);
    const subHeaderRef = useRef<HTMLDivElement | null>(null);
    const cardRef = useRef<HTMLDivElement | null>(null);
    const [tableHeight, setTableHeight] = useState(0);
    const [exportAnchorEl,setExportAnchorEl]  = useState(null);
    const [filtersVisible,setFiltersVisible]  = useState(false); 
    const [showComponentCard, setShowComponentCard] = useState(false);
    const [exportingFile,setExportingFile] = useState(false);
    const [selectedComponent, setSelectedComponent] = useState<IInvenotryParamComponentsReferenceData | null>(null);
    const selectedComponentRef = useRef(selectedComponent);

    const chargerInventoryParameterChangeLogsListTablePropsRef = useRef(chargerInventoryParameterChangeLogsListTableProps);

    useEffect(() => {
        chargerInventoryParameterChangeLogsListTablePropsRef.current = chargerInventoryParameterChangeLogsListTableProps
    }, [chargerInventoryParameterChangeLogsListTableProps]);

    const {individualChargerDetail} = useAppSelector(getChargerReducer);


    const layoutCallback = useCallback(
        async (
            pageNumber: number,
            pageSize: number,
            view: string,
            field: string | null,
            order: string,
            filterData,
            searchTerm: string,
        ) => {
            const tableProps = cloneDeep(chargerInventoryParameterChangeLogsListTablePropsRef?.current);
            const inventoryParamChangeLogsFilter = getCurrentFiltersValues('inventoryParamChangeLogs',true);
            const appliedFilters = filterData ? filterData : inventoryParamChangeLogsFilter;

            await dispatch(
                fetchInventoryParameterChangeLogs({
                    sortBy: field || tableProps?.sortBy,
                    order: order || tableProps?.order,
                    view: view || tableProps?.view,
                    pageSize: pageSize,
                    pageNumber: pageNumber,
                    filters: appliedFilters,
                    searchTerm: searchTerm != null ? searchTerm : tableProps?.searchTerm,
                    chargerId: location?.state?.chargerId,
                    device: selectedComponentRef?.current?.device ?? null,
                    connectorNo: selectedComponentRef?.current?.connector ?? null,
                    smrUnitNo: selectedComponentRef?.current?.smrUnitNo ?? null
                })
            );

            if (tableProps) {
                tableProps.sortBy = field || chargerInventoryParameterChangeLogsListTablePropsRef?.current?.sortBy;
                tableProps.order = order || chargerInventoryParameterChangeLogsListTablePropsRef?.current?.order;
                tableProps.pageNumber = pageNumber;
                tableProps.pageSize = pageSize;
                if (searchTerm != null && searchTerm != undefined) {
                    tableProps.searchTerm = searchTerm;
                }
            }
            await dispatch(setInventoryParameterChangeLogsTableProps(tableProps));
        },
        [chargerInventoryParameterChangeLogsListTablePropsRef?.current, dispatch,location]
    );

    const preventClickEventPropagation = (e: React.MouseEvent): void => {
        e.stopPropagation();
    };

    const fileDownloadSuccessToast = useCallback((): Id => {
        setExportingFile(false);
        return toast.success('File downloaded.');
    }, []);

    const fileDownloadFailureToast = useCallback((): Id => {
        setExportingFile(false);
        return toast.warn('Something went wrong. Please export again.');
    }, []);

    const onChangeOfSearchText = useCallback(async (searchText: string) => {
        const trimmedSearchText = searchText.trim();
        const tableProps = cloneDeep(chargerInventoryParameterChangeLogsListTablePropsRef?.current);
        if (tableProps) {
            tableProps.searchTerm = trimmedSearchText;
        }
        const inventoryParamChangeLogsFilter = getCurrentFiltersValues('inventoryParamChangeLogs',true);
        await layoutCallback(
            1,
            tableProps?.pageSize,
            tableProps?.view,
            tableProps?.sortBy,
            tableProps?.order,
            inventoryParamChangeLogsFilter,
            trimmedSearchText,
        )
    }, [chargerInventoryParameterChangeLogsListTablePropsRef?.current, layoutCallback]);

    const searchBoxConfiguration = useMemo(() => {
            return {
                searchBoxClassName: 'inventory__component__change__logs__search__box',
                searchFieldId: 'inventory-component-change-logs-search-box',
                searchFieldName: 'inventory-component-change-logs-search-box',
                handleSearch: onChangeOfSearchText,
            };
    }, []);

    const calculateContentHeight = useCallback(()=>{
        if (dashboardRef?.current && headerRef?.current && subHeaderRef?.current && cardRef?.current) {
            const dashboardRect = dashboardRef?.current?.getBoundingClientRect();
            const headerRect = headerRef?.current?.getBoundingClientRect();
            const subHeaderRect = subHeaderRef?.current?.getBoundingClientRect();
            const cardRect = cardRef?.current?.getBoundingClientRect();

            const dashboardHeight = dashboardRect?.height;
            const headerHeight = headerRect?.height;
            const subHeaderHeight = subHeaderRect?.height;
            const cardHeight = cardRect?.height;

            const newTableHeight = dashboardHeight - headerHeight - subHeaderHeight - cardHeight - 40;
            setTableHeight(newTableHeight);
        }
    
    },[dashboardRef?.current,headerRef?.current, subHeaderRef?.current, cardRef?.current]);

    useEffect(()=>{
        const ro = new ResizeObserver(()=>{
            calculateContentHeight();
        });

        if(dashboardRef?.current) ro.observe(dashboardRef?.current);
        if(headerRef?.current) ro.observe(headerRef?.current);
        if(subHeaderRef?.current) ro.observe(subHeaderRef?.current);
        if(cardRef?.current) ro.observe(cardRef?.current);

        return ()=>{
            ro.disconnect();
        }
    },[calculateContentHeight]);

    const headerActionBtns = useMemo(()=>renderHeaderActionButtons({
        actionBtns:
        [
            {
                id: 'add_filter_btn',
                isAccessible: true,
                headerActionBtnClick: (event): void => {
                    // setFilterAnchorEl(event.currentTarget)
                    setFiltersVisible(true);
                },
                badgeCount: getCurrentScreenAppliedFiltersCount('inventoryParamChangeLogs', true)
            },
            {
                id: 'export_csv_btn',
                isAccessible: true,
                headerActionBtnClick: (event): void => {
                    setExportAnchorEl(event.currentTarget);
                },
            },
        ]
    }),[screenFilters]);

    const handleClose = (): void => {
        setExportAnchorEl(null);
    };

    const handleFiltersClosePopOver = (): void => {
        setFiltersVisible(false);
    };

    const handleComponentSelection =  useCallback(async(value) => {
        setSelectedComponent(value);
        if(value?.id === 'all') {
            setShowComponentCard(false);
            setSelectedComponent(null);
            selectedComponentRef.current = null;
            dispatch(clearInventoryParamIndividualComponentDetailsComponent());
        } else {
            selectedComponentRef.current = value;
            try {
                const reqBody = {
                    device: value?.device,
                    connectorNo: value?.connector,
                    smrUnitNo: value?.smrUnitNo,
                    chargerId: location?.state?.chargerId
                }
                await dispatch(fetchInventoryParamIndividualComponentDetailsComponent(reqBody));
                setShowComponentCard(true);
            } catch (error) {
                console.log(error);
                setShowComponentCard(false);
                dispatch(clearInventoryParamIndividualComponentDetailsComponent());
            }
        }
        try {
            const tableProps = cloneDeep(chargerInventoryParameterChangeLogsListTablePropsRef?.current);
            await layoutCallback(
                1,
                tableProps?.pageSize,
                tableProps?.view,
                tableProps?.sortBy,
                tableProps?.order,
                null,
                tableProps?.searchTerm ?? '',
            )
        } catch (error) {
            console.log(error);
        }
    },[location, dispatch, layoutCallback])

    const onExportBtnClick = useCallback(async (fileType: 'csv' | 'xlsx'): Promise<void> => {
        if (exportingFile) {
          // If already exporting, prevent another export
          return;
        }
        try {
          const response = await dispatch(exportInventoryParameterChangeLogs({
            fileType: fileType,
            filters: getCurrentFiltersValues('inventoryParamChangeLogs',true),
            connectorNo: selectedComponentRef?.current?.connector,
            smrUnitNo: selectedComponentRef?.current?.smrUnitNo,
            device: selectedComponentRef?.current?.device,
            chargerId: location?.state?.chargerId
          }));
          if (response?.status === 202 || response?.status === 200) {
            downloadFile({ url: response?.data?.url });
            fileDownloadSuccessToast()
          } else {
            fileDownloadFailureToast();
            setExportAnchorEl(null);
          }
        } finally {
          // Ensure that exporting status is updated even if there's an error
          setExportingFile(false);
          setExportAnchorEl(null);
    
        }
      }, [exportingFile, fileDownloadSuccessToast, fileDownloadFailureToast, location]);

    const onResetButtonClick = useCallback(async (callList: boolean) => {
        const res = await setFilterData(null, '', 'inventoryParamChangeLogs', 'CLEAR', false)(dispatch);
        if (res?.message === 'Action dispatched successfully') {
            if (callList && chargerInventoryParameterChangeLogsListTablePropsRef?.current) {
                const tableProps = cloneDeep(chargerInventoryParameterChangeLogsListTablePropsRef?.current);
                await layoutCallback(
                    1,
                    tableProps?.pageSize,
                    tableProps?.view,
                    tableProps?.sortBy,
                    tableProps?.order,
                    res?.filters,
                    tableProps?.searchTerm ?? '',
                )
            }
        }
    }, [chargerInventoryParameterChangeLogsListTablePropsRef?.current,chargerInventoryParameterChangeLogsFiltersAppliedFromRedirection])

    const filterFooterBtns = useMemo(() => {
        return [
        {
            buttonText: 'Reset',
            buttonId: 'Reset',
            btnClassName: 'secondary__btn',
            handleClick: (): Promise<void> => onResetButtonClick(true),
            isDisabled: false,
            buttonVariant: 'outlined',
        },
        ];
    }, [onResetButtonClick]);

    const handleFilterDataChange = useCallback(async (data, filterKey: string, isGlobal: boolean) => {
        const tableProps = cloneDeep(chargerInventoryParameterChangeLogsListTablePropsRef?.current);
        const res = await setFilterData(data, filterKey, 'inventoryParamChangeLogs', 'SET', isGlobal,true)(dispatch);
        if (res?.message === 'Action dispatched successfully') {
            await layoutCallback?.(
                1,
                tableProps?.pageSize,
                tableProps?.view,
                tableProps?.sortBy,
                tableProps?.order,
                res?.filters,
                tableProps?.searchTerm ?? '',
            )
        }
    }, [chargerInventoryParameterChangeLogsListTablePropsRef?.current]);


    const getTableRows = useCallback((): IInventoryParameterChangeLog[] => {
        return chargerInventoryParameterChangeLogs !== null && chargerInventoryParameterChangeLogs?.length > 0 ? chargerInventoryParameterChangeLogs : [];
    }, [chargerInventoryParameterChangeLogs]);


    const changeLogFilterProps: FilterProp[] = useMemo(()=>{
        const changeLogCreatedOnDateRange = getFilterSelectedValue('changeLogLoggedAt', 'inventoryParamChangeLogs', false);

        return [
            {
                filterLabel: 'Field',
                filterType: 'dropdown',
                filterId: 'changeLogFieldName',
                filterDropdownProps: {
                    selectValue: getFilterSelectedValue('changeLogFieldName', 'inventoryParamChangeLogs', false),
                    selectOptions: inventoryParamChangeLogFieldNameReferenceData ?? [],
                    handleSelectOptionChange: (val): void => {
                        handleFilterDataChange(val, 'changeLogFieldName', false)
                    },
                    selectDropDownId: 'change-log-field-name-filter-dropdown',
                    isMultiSelect: true,
                    renderToBody:true,
                }
            },
            {
                filterLabel: 'Status',
                filterType: 'dropdown',
                filterId: 'changeLogChangeType',
                filterDropdownProps: {
                    selectValue: getFilterSelectedValue('changeLogChangeType', 'inventoryParamChangeLogs', false),
                    selectOptions: inventoryParamChangeLogChangeTypeReferenceData ?? [],
                    handleSelectOptionChange: (val): void => {
                        handleFilterDataChange(val, 'changeLogChangeType', false)
                    },
                    selectDropDownId: 'change-log-field-name-filter-dropdown',
                    isMultiSelect: true,
                    renderToBody:true,
                }
            },
            {
                filterLabel: 'Changed At',
                filterId: 'changeLogLoggedAt',
                filterType: 'dateFilter' as 'dropdown' | 'dateFilter',
                dateFilterProps: {
                    datePickerId: 'inventory-parameter-changed-on-picker',
                    datePickerClassName: '',
                    selectsRange: true,
                    startDate: changeLogCreatedOnDateRange?.[0]
                        ? new Date(changeLogCreatedOnDateRange?.[0])
                        : null,
                    endDate: changeLogCreatedOnDateRange?.[1]
                        ? new Date(changeLogCreatedOnDateRange?.[1])
                        : null,
                    onChange: (val): void => {
                        handleFilterDataChange(val, 'changeLogLoggedAt', false);
                    },
                    renderToBody: true,
                },
            }
        ]

    },[screenFilters,inventoryParamChangeLogFieldNameReferenceData,inventoryParamChangeLogChangeTypeReferenceData])


    useEffectOnce(()=>{
        dispatch(fetchInventoryParamComponentsReferenceData({chargerId: location?.state?.chargerId}));
    })

    const changeLogColumns = [
        {
            field: 'card',
            headerName: '',
            flex: 1,
            sortable: false,
            filterable: false,
            resizable: false,
            disableColumnMenu: true,
        },
    ];

    const changeLogsListCleanUpState = useCallback(() => {
        const action = {
            type: chargerTypes.CLEAR_CHARGER_INVENTORY_PARAMS_CHANGE_LOGS_DATA,
        }
        dispatch(action)
        if (chargerInventoryParameterChangeLogsFiltersAppliedFromRedirection) {
            onResetButtonClick(true)
        }
       setRedirectedStateForInventoryParameterChangeLogsFilters(false)(dispatch)
    }, [chargerInventoryParameterChangeLogsFiltersAppliedFromRedirection])
    
    useEffect(() => {
        window.addEventListener('beforeunload', changeLogsListCleanUpState);
        return (): void => {
            changeLogsListCleanUpState()
            window.removeEventListener('beforeunload', changeLogsListCleanUpState)
        }
    }, [])


    return (
        <div
            className='charger__inventory__parameter__change__log__dashboard__container'
            onClick={preventClickEventPropagation}
            ref={dashboardRef}
        >
            <div className='charger__inventory__parameter__change__log__dashboard-header-container' ref={headerRef}>
                <div className='charger__inventory__parameter__change__log__dashboard'>
                    <div className='charger__inventory__parameter__change__log__dashboard-left'>
                        <div className='charger__inventory__parameter__change__log__dashboard-header-text'>
                            <DashboardHeader header="Change Logs" />
                            <IconWithTooltip iconClassName='info-icon' toolTipText={'Audit trail for every Inventory Parameter change'}/>
                        </div>
                        {
                           individualChargerDetail && <div className='charger__inventory__parameter__change__log__chager__details'>
                                <div className='charger__inventory__param__charger__details__label'>{individualChargerDetail?.chargerVisibleId}</div>

                                {/* separator */}
                                <div className='charger__inventory__param__charger_details__separator'></div>

                                <div className='charger__inventory__param__charger__details__label'>Product Type: {individualChargerDetail?.productType}</div>

                                {/* separator */}
                                <div className='charger__inventory__param__charger_details__separator'></div>

                                <div className='charger__inventory__param__charger__details__label'>Customer: {individualChargerDetail?.customerName}</div>
                            </div>
                        }
                    </div>
                    <div className='charger__inventory__parameter__change__log__dashboard-right'>
                        <TableSubHeader headerActionBtns={headerActionBtns}/>
                        <div className='charger__inventory__parameter__change__log__dashboard-close-icon-container'>
                            <Icon iconClassName='filter__cancel__icon' onIconClick={handleCloseIconClicked}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className='charger__inventory__parameter__change__log__dashboard-sub-header-container' ref={subHeaderRef}>
                <div className='charger__inventory__parameter__change__log__search__box__container'>
                    <SearchBox 
                    searchFieldId={searchBoxConfiguration.searchFieldId}
                    searchBoxClassName={searchBoxConfiguration.searchBoxClassName}
                    searchFieldName={searchBoxConfiguration.searchFieldName}
                    handleSearch = {searchBoxConfiguration.handleSearch}
                    />
                </div>
                <div className='charger__inventory__parameter__change__log__component__filter__container'>
                    <div className='charger__inventory__parameter__change__log__component__filter__label'>Components</div>
                    <SelectDropDown 
                        selectDropDownId={'inventory-param-change-log-component-dropdown'} 
                        dropDownClassName={'inventory__param__change__log__component__dropdown'} 
                        selectValue={selectedComponent ?? null}
                        selectOptions={inventoryParamComponentsReferenceData ?? []} 
                        handleSelectOptionChange={handleComponentSelection}
                    />
                </div>
            </div>
            <div className='charger__inventory__parameter__change__log__dashboard-body-container'>
                <div className='charger__inventory__selected__component__card__container' ref={cardRef}>
                    { showComponentCard && <InventoryParamCurrentStatusCard componentData={inventoryParameterIndividualComponentDetails}/> }
                </div> 
                <div className='charger__inventory__selected__change__logs__table__container' style={{height:`${tableHeight}px`}}>
                    <TableLayout
                        key={'inventory__parameter__change__log__table'}
                        tableId='inventory-parameter-change-log-table'
                        tableClassName='inventory__parameter__change__log__table'
                        layoutView='list'
                        gridColumns={changeLogColumns}
                        tableRows={getTableRows()}
                        listLayoutCallBack={layoutCallback}
                        totalCount={chargerInventoryParameterChangeLogsCount ?? 0}
                        totalCountText='changes'
                        renderCustomRowComponent
                        customRowComponent={ChargerInventoryParameterChangeLogRowCard}
                        showLoader={chargerInventoryParameterChangeLogsListLoader}
                        showSkeleton={false}
                        customNoDataComponent={NoDataComponentInventoryParamChangeLog}
                        disableHeader={true}
                        tablePageSize={chargerInventoryParameterChangeLogsListTableProps?.pageSize}
                        pageNumber={chargerInventoryParameterChangeLogsListTableProps?.pageNumber}
                        sortField={chargerInventoryParameterChangeLogsListTableProps?.sortBy}
                        sortOrder={chargerInventoryParameterChangeLogsListTableProps?.order}
                    />
                </div>
            </div>



            <>
                {
                filtersVisible && <SidePopover
                    id={'change-log-side-filters'}
                    open={filtersVisible}
                    containerClassName={'change-log-side-filters'}
                    handleClose={handleFiltersClosePopOver}
                    headerText={'Add Filters'}
                    disablePortal={true}
                    anchorReference={'none'}
                    rootClassName={'change-log-side-popover-root'}
                    popperClassName={'change-log-side-popover-paper'}
                    // eslint-disable-next-line react/no-children-prop
                    children={<FilterLayout requiredReferenceDataCallbacks={['changeLogFieldName','changeLogChangeType']}
                        filters={changeLogFilterProps} handleFilterDataChange={handleFilterDataChange}
                        excludeGlobalFilters={true}
                    />}
                    btnsList={filterFooterBtns}
                    />
                }
            </>

            <>
                <Menu
                    id="export-option-dropdown"
                    anchorEl={exportAnchorEl}
                    anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                    }}
                    className='export__option__dropdown'
                    sx={{ top: '30px' }}
                    open={Boolean(exportAnchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem>
                    <div className='export__btn-option' onClick={(e) => {
                        e?.stopPropagation();
                        onExportBtnClick('csv')
                    }}>
                        To CSV
                    </div>
                    </MenuItem>
                    <MenuItem>
                    <div className='export__btn-option' onClick={(e) => {
                        e?.stopPropagation();
                        onExportBtnClick('xlsx')
                    }}>
                        To Excel
                    </div>
                    </MenuItem>
                </Menu>
            </>
        </div>
    );
}

export default React.memo(ChargerInventoryParameterChangeLogDashboard);
